export const upsellings = {
    text1: "Servizi",
    text2: "Gestisci i tuoi servizi",
    text3: "Elenco dei servizi",
    text4: "Fornitori",
    text5: "Elenco dei servizi che vedranno i tuoi ospiti",
    text6: "Registra servizio",
    text7: "Nome",
    text8: "Creato",
    text9: "Stato",
    text10: "attivo",
    text11: "inattivo",
    text12: "Modifica servizio",
    text13: "Elimina servizio",
    text14: "Nessun servizio trovato.",
    text15: "Modificato correttamente.",
    text16: "Sei sicuro di voler eliminare il servizio",
    text17: "Perderai i dati salvati",
    text18: "Elimina servizio",
    text19: "Annulla",
    text20: "Eliminato correttamente.",
    text21: "Crea servizio",
    text22: "Informazioni sul servizio",
    text23: "Inserisci le informazioni principali del servizio mostrate sulla scheda.",
    text24: "Tutti gli alloggi",
    text25: "Seleziona alloggio *",
    text26: "Inserisci il nome",
    text27: "Nome del tuo servizio *",
    text28: "Automatica",
    text29: "Manuale",
    text30: "Tipo di conferma",
    text31: "Titolo del servizio",
    text32: "Inserisci il titolo *",
    text33: "Check-in/check-out",
    text34: "Transfer",
    text35: "F&B",
    text36: "Stagionale",
    text37: "Famiglia",
    text38: "Romantico",
    text39: "SPA e benessere",
    text40: "Arte e cultura",
    text41: "Attività",
    text42: "Servizi",
    text43: "Altri",
    text44: "Categoria *",
    text45: "Servizio interno",
    text46: "Fornitore *",
    text47: "Descrizione",
    text48: "Inserisci la descrizione del tuo servizio *",
    text49: "Prezzo",
    text50: "Seleziona il tipo di prezzo e definisci quanto i tuoi ospiti pagheranno per l'offerta.",
    text51: "Inserisci il numero",
    text52: "Per unità",
    text53: "Per persona",
    text54: "Per gruppo",
    text55: "Per giorno",
    text555: "Per ora",
    text56: "Prezzo per",
    text57: "Immagine",
    text58: "Carica un'immagine che verrà posizionata nell'intestazione della scheda.",
    text59: "Salva servizio",
    text60: "Caricamento ...",
    text61: "Servizio creato correttamente.",
    text62: "Elenco dei fornitori",
    text63: "Aggiungi fornitore",
    text64: "ID",
    text65: "Nome",
    text66: "Email",
    text67: "Telefono",
    text68: "Modifica fornitore",
    text69: "Rimuovi fornitore",
    text70: "Registra fornitore",
    text71: "Aggiungi ",
    text72: "fornitori ",
    text73: "al tuo elenco per poterli utilizzare nella creazione di nuove offerte.",
    text74: "Inserisci il nome",
    text75: "Nome del fornitore *",
    text76: "Paese",
    text77: "Errore",
    text78: "Inserisci il tuo numero",
    text79: "Telefono *",
    text80: "Indirizzo e-mail *",
    text81: "Indirizzo",
    text82: "Aggiungi fornitore",
    text83: "Creato con successo.",
    text84: "Sei sicuro di voler eliminare il fornitore?",
    text85: "Perderai i dati salvati",
    text86: "Rimuovi fornitore",
    text87: "Eliminato correttamente.",
    text96: 'Gestisci i tuoi abbonamenti e le tue fatture',

    // Correcciones
    p1: "Prezzo su richiesta",
};